module.exports = __webpack_public_path__ + "static/80402098_546514055899254_5823654540146114560_n_optimized-c242ffbc6fa190f93b112c73cc5a5514.jpg";